"use strict";
var lodash_1 = require("lodash");
var attribute_1 = require("./attribute");
var gpml_utilities_1 = require("./gpml-utilities");
var he_1 = require("he");
var tower_strcase_1 = require("tower-strcase");
var RGBColor = require("rgbcolor");
var anchor_1 = require("./anchor");
var pathway_1 = require("./pathway");
var group_1 = require("./group");
var data_node_1 = require("./data-node");
var graphical_line_1 = require("./graphical-line");
var interaction_1 = require("./interaction");
var label_1 = require("./label");
var shape_1 = require("./shape");
var state_1 = require("./state");
var defaultsAppliers = {
    Anchor: anchor_1.applyDefaults,
    Pathway: pathway_1.applyDefaults,
    Group: group_1.applyDefaults,
    DataNode: data_node_1.applyDefaults,
    GraphicalLine: graphical_line_1.applyDefaults,
    Interaction: interaction_1.applyDefaults,
    Label: label_1.applyDefaults,
    Shape: shape_1.applyDefaults,
    State: state_1.applyDefaults,
};
function parseAsNonNaNNumber(i) {
    var parsed = Number(i);
    if (lodash_1.isNaN(parsed)) {
        throw new Error('Cannot parse "' + String(i) + '" as non-NaN number');
    }
    return parsed;
}
var DEFAULTS = {
    attributes: {
        FillColor: {
            name: 'FillColor',
            value: 'ffffff'
        }
    }
};
function applyDefaults(gpmlElement) {
    var gpmlElementName = gpmlElement.name;
    if (defaultsAppliers.hasOwnProperty(gpmlElementName)) {
        return defaultsAppliers[gpmlElementName](gpmlElement, DEFAULTS);
    }
    else {
        return gpml_utilities_1.applyDefaults(gpmlElement, DEFAULTS);
    }
}
exports.applyDefaults = applyDefaults;
;
function fromGPML(data, dataElement, inputGPMLElement) {
    var gpmlElement = applyDefaults(inputGPMLElement);
    var gpmlElementName = dataElement.gpmlElementName = gpmlElement.name;
    // Note side-effects required for these values,
    // because subsequent values depend on them.
    var gpmlShapeType = '';
    var lineStyleIsDouble;
    var dataBorderWidth;
    var gpmlRotation;
    var ATTRIBUTE_DEPENDENCY_ORDER = [
        'GraphId',
        'GroupId',
        'GraphRef',
        'GroupRef',
        'Name',
        'TextLabel',
        'Type',
        'CellularComponent',
        'Rotation',
        'LineStyle',
        'Shape',
        'ShapeType',
        'Attribute',
        'FillColor',
        'Color',
        'LineThickness',
        'Width',
        'Height',
        'RelX',
        'RelY',
        'CenterX',
        'CenterY',
        'ConnectorType',
        'Point',
        'Organism',
        'Database',
        'ID',
        'Data-Source',
        'Version',
    ];
    // processes Shape and ShapeType GPML attributes 
    function processShapeType(gpmlValue) {
        gpmlShapeType = dataElement.drawAs = gpmlValue;
    }
    var GPML_ALIGN_TO_TEXTALIGN = {
        Middle: 'center',
        Left: 'start',
        Right: 'end',
    };
    var gpmlToDataConverter = {
        Align: function (gpmlAlignValue) {
            dataElement.textAlign = GPML_ALIGN_TO_TEXTALIGN[gpmlAlignValue];
        },
        Attribute: function (gpmlValue) {
            // NOTE: in GPML, 'Attribute' is an XML _ELEMENT_ with the gpmlElementName "Attribute."
            // We push all the Attribute elements that are children of the current target
            // element onto an array in JSON before reaching this step.
            gpmlValue.forEach(function (attributeElement) {
                dataElement = attribute_1.fromGPML(dataElement, gpmlElement, attributeElement);
            });
        },
        Author: function (gpmlValue) {
            if (gpmlValue) {
                dataElement.author = he_1.decode(gpmlValue);
            }
        },
        BiopaxRef: function (gpmlValue) {
            // NOTE: BiopaxRefs come into here grouped into an array.
            //       See SUPPLEMENTAL_ELEMENTS_WITH_TEXT in toPvjson.ts
            if (!lodash_1.isEmpty(gpmlValue)) {
                dataElement.citation = gpmlValue.map(gpml_utilities_1.generatePublicationXrefId);
            }
        },
        BoardHeight: function (gpmlValue) {
            dataElement.height = parseAsNonNaNNumber(gpmlValue);
        },
        BoardWidth: function (gpmlValue) {
            dataElement.width = parseAsNonNaNNumber(gpmlValue);
        },
        CenterX: function (gpmlValue) {
            dataElement.x = parseAsNonNaNNumber(gpmlValue) - dataElement.width / 2;
        },
        CenterY: function (gpmlValue) {
            dataElement.y = parseAsNonNaNNumber(gpmlValue) - dataElement.height / 2;
            var transformationSequence = [];
            // Correct GPML position and size values.
            //
            // Some GPML elements with ShapeTypes have Graphics values that
            // do not match what is visually displayed in PathVisio-Java.
            // Below are corrections for the GPML so that the display in
            // pvjs matches the display in PathVisio-Java.
            var xTranslation;
            var yTranslation;
            var xScale;
            var yScale;
            if (gpmlShapeType === 'Triangle') {
                // NOTE: the numbers below come from visually experimenting with different widths
                // in PathVisio-Java and making linear approximations of the translation
                // scaling required to make x, y, width and height values match what is visually
                // displayed in PathVisio-Java.
                xScale = ((dataElement.width + 0.04) / 1.07) / dataElement.width;
                yScale = ((dataElement.height - 0.14) / 1.15) / dataElement.height;
                xTranslation = 0.28 * dataElement.width - 2.00;
                yTranslation = 0;
                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: gpmlRotation
                    });
                }
                transformationSequence.push({
                    key: 'translate',
                    value: [xTranslation, yTranslation]
                });
                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: (-1) * gpmlRotation
                    });
                }
                transformationSequence.push({
                    key: 'scale',
                    value: [xScale, yScale]
                });
            }
            else if (gpmlShapeType === 'Hexagon') {
                xScale = 1;
                yScale = 0.88;
                transformationSequence.push({
                    key: 'scale',
                    value: [xScale, yScale]
                });
            }
            else if (gpmlShapeType === 'Pentagon') {
                xScale = 0.90;
                yScale = 0.95;
                xTranslation = 0.047 * dataElement.width + 0.01;
                yTranslation = 0;
                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: gpmlRotation
                    });
                }
                transformationSequence.push({
                    key: 'translate',
                    value: [xTranslation, yTranslation]
                });
                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: (-1) * gpmlRotation
                    });
                }
                transformationSequence.push({
                    key: 'scale',
                    value: [xScale, yScale]
                });
            }
            else if (gpmlShapeType === 'Arc') {
                xScale = 1;
                yScale = 0.5;
                xTranslation = 0;
                yTranslation = dataElement.height * yScale / 2;
                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: gpmlRotation
                    });
                }
                transformationSequence.push({
                    key: 'translate',
                    value: [xTranslation, yTranslation]
                });
                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: (-1) * gpmlRotation
                    });
                }
                transformationSequence.push({
                    key: 'scale',
                    value: [xScale, yScale]
                });
            }
            /*
            else if (gpmlShapeType === 'Sarcoplasmic Reticulum') {
            // TODO: enable this after comparing results from old converter
                xScale = 0.76;
                yScale = 0.94;
                xTranslation = 0.043 * dataElement.width + 0.01;
                yTranslation = 0.009 * dataElement.height - 15.94;

                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: gpmlRotation
                    });
                }

                transformationSequence.push({
                    key: 'translate',
                    value: [xTranslation, yTranslation]
                });

                if (typeof gpmlRotation === 'number' && gpmlRotation !== 0) {
                    transformationSequence.push({
                        key: 'rotate',
                        value: (-1) * gpmlRotation
                    });
                }

                transformationSequence.push({
                    key: 'scale',
                    value: [xScale, yScale]
                });
            }
            //*/
            dataElement = gpml_utilities_1.transform({
                element: dataElement,
                transformationSequence: transformationSequence
            });
        },
        Color: function (gpmlColorValue) {
            var cssColor = this.gpmlColorToCssColor(gpmlColorValue);
            dataElement.color = cssColor;
        },
        Comment: function (gpmlValue) {
            // NOTE: comments come into here grouped into an array.
            //       See tagNamesForSupplementalElementsWithText in main.ts
            if (!lodash_1.isEmpty(gpmlValue)) {
                dataElement.comment = gpmlValue.map(function (c) { return he_1.decode(c); });
            }
        },
        ConnectorType: function (gpmlConnectorTypeValue) {
            var gpmlConnectorType = gpmlConnectorTypeValue;
            dataElement.drawAs = gpmlConnectorType + 'Line';
        },
        Database: function (gpmlValue) {
            if (gpmlValue) {
                dataElement.dbName = gpmlValue.trim();
            }
        },
        'Data-Source': function (gpmlValue) {
            if (gpmlValue) {
                dataElement.dataSource = he_1.decode(gpmlValue);
            }
        },
        Email: function (gpmlValue) {
            if (gpmlValue) {
                dataElement.email = he_1.decode(gpmlValue);
            }
        },
        FillColor: function (gpmlFillColorValue) {
            var cssColor = this.gpmlColorToCssColor(gpmlFillColorValue);
            if (gpmlShapeType.toLowerCase() !== 'none') {
                dataElement.backgroundColor = cssColor;
            }
            else {
                dataElement.backgroundColor = 'transparent';
            }
        },
        FillOpacity: function (gpmlFillOpacityValue) {
            var cssFillOpacity = parseAsNonNaNNumber(gpmlFillOpacityValue);
            dataElement.fillOpacity = cssFillOpacity;
        },
        FontName: function (gpmlFontNameValue) {
            dataElement.fontFamily = gpmlFontNameValue;
        },
        FontSize: function (gpmlFontSizeValue) {
            dataElement.fontSize = parseAsNonNaNNumber(gpmlFontSizeValue);
        },
        FontStyle: function (gpmlFontStyleValue) {
            var cssFontStyle = gpmlFontStyleValue.toLowerCase();
            dataElement.fontStyle = cssFontStyle;
        },
        FontWeight: function (gpmlFontWeightValue) {
            var cssFontWeight = gpmlFontWeightValue.toLowerCase();
            dataElement.fontWeight = cssFontWeight;
        },
        GraphId: function (gpmlValue) {
            dataElement.id = gpmlValue;
        },
        GraphRef: function (gpmlValue) {
            dataElement.isAttachedTo = gpmlValue;
        },
        GroupId: function (gpmlValue) {
            data.GraphIdToGroupId[dataElement.id] = gpmlValue;
        },
        GroupRef: function (gpmlValue) {
            var groupContents = data.containedIdsByGroupId[gpmlValue] = data.containedIdsByGroupId[gpmlValue] || [];
            groupContents.push(dataElement.id);
        },
        Height: function (gpmlValue) {
            // NOTE: this will be corrected, if needed, when CenterY is evaluated
            dataElement.height = parseAsNonNaNNumber(gpmlValue) + dataBorderWidth;
            if (lineStyleIsDouble) {
                dataElement.height += dataBorderWidth;
            }
        },
        Href: function (gpmlHrefValue) {
            if (gpmlHrefValue) {
                dataElement.href = encodeURI(he_1.decode(gpmlHrefValue));
            }
        },
        ID: function (gpmlValue) {
            if (gpmlValue) {
                dataElement.dbId = gpmlValue.trim();
            }
        },
        'Last-Modified': function (gpmlValue) {
            dataElement.lastModified = gpmlValue;
        },
        License: function (gpmlValue) {
            if (gpmlValue) {
                dataElement.license = he_1.decode(gpmlValue);
            }
        },
        LineStyle: function (gpmlLineStyleValue) {
            dataElement.lineStyle = gpmlLineStyleValue;
            var dataStrokeDasharray;
            // TODO hard-coding these here is not the most maintainable
            if (gpmlLineStyleValue === 'Broken') {
                dataStrokeDasharray = '5,3';
                dataElement.strokeDasharray = dataStrokeDasharray;
            }
            else if (gpmlLineStyleValue === 'Double') {
                lineStyleIsDouble = true;
            }
        },
        LineThickness: function (gpmlLineThicknessValue) {
            dataBorderWidth = parseAsNonNaNNumber(gpmlLineThicknessValue);
            // In PathVisio-Java, GPML Width/Height for GPML Shapes is
            // inconsistent when zoomed in vs. when at default zoom level.
            //
            // When zoomed in, GPML Width/Height refers to the distance from
            // center of border to center of border, meaning that shapes that
            // run up to the edge will be cropped.
            //
            // When at default zoom level, GPML Width/Height refers to the distance
            // from outer edge of border to outer edge of border (no cropping).
            //
            // Because of this, LineThickness for Rectangle and RoundedRectangle
            // is also inconsistent.
            // When zoomed in: one half of specified LineThickness.
            // When at default zoom level: full specified LineThickness.
            //
            // For pvjs, we attempt to match the view from PathVisio-Java when zoomed out,
            // but we define width/height as outer border edge to outer border edge, meaning
            // data width/height values will not match GPML Width/Height values.
            //
            // data width = GPML Width + GPML LineThickness
            // data height = GPML Height + GPML LineThickness
            // (one half LineThickness on either side yields a full LineThickness to add
            // to width/height).
            //
            // Also note that for double lines, LineThickness refers to the the border
            // width of each line and the space between each line, meaning the border width
            // for the double line as a whole will be three times the listed LineThickness.
            dataElement.borderWidth = dataBorderWidth;
        },
        Maintainer: function (gpmlValue) {
            if (gpmlValue) {
                dataElement.maintainer = he_1.decode(gpmlValue);
            }
        },
        Name: function (nameValue) {
            if (nameValue) {
                dataElement.name = he_1.decode(nameValue);
                var splitName = nameValue.split(' (');
                if (!!splitName &&
                    splitName.length === 2 &&
                    !!nameValue.match(/\(/g) &&
                    nameValue.match(/\(/g).length === 1 &&
                    !!nameValue.match(/\)/g) &&
                    nameValue.match(/\)/g).length === 1) {
                    dataElement.standardName = splitName[0];
                    dataElement.displayName = splitName[1].replace(')', '');
                }
                else {
                    dataElement.standardName = nameValue;
                    dataElement.displayName = nameValue;
                }
            }
        },
        Organism: function (gpmlValue) {
            dataElement.organism = gpmlValue;
        },
        Padding: function (gpmlPaddingValue) {
            dataElement.padding = gpmlPaddingValue;
        },
        Point: function (gpmlValue) {
            // Saving this to fully convert later (after every appropriate element has been put into data.elementMap).
            dataElement['gpml:Point'] = gpmlValue;
        },
        Position: function (gpmlPositionValue) {
            dataElement.attachmentDisplay = {
                position: [parseAsNonNaNNumber(gpmlPositionValue)]
            };
        },
        RelX: function (gpmlValue) {
            var attachmentDisplay = dataElement.attachmentDisplay = dataElement.attachmentDisplay || {};
            var position = attachmentDisplay.position = attachmentDisplay.position || [];
            var gpmlRelX = parseAsNonNaNNumber(gpmlValue);
            position[0] = (gpmlRelX + 1) / 2;
        },
        RelY: function (gpmlValue) {
            var attachmentDisplay = dataElement.attachmentDisplay = dataElement.attachmentDisplay || {};
            var position = attachmentDisplay.position = attachmentDisplay.position || [];
            var gpmlRelY = parseAsNonNaNNumber(gpmlValue);
            position[1] = (gpmlRelY + 1) / 2;
        },
        Rotation: function (gpmlValue) {
            // GPML can hold a rotation value for State elements in an element
            // named "Attribute" like this:
            // Key="org.pathvisio.core.StateRotation"
            // From discussion with AP and KH, we've decided to ignore this value,
            // because we don't actually want States to be rotated.
            gpmlRotation = parseAsNonNaNNumber(gpmlValue);
            // GPML saves rotation in radians, even though PathVisio-Java displays rotation in degrees.
            // Convert from radians to degrees:
            var dataRotation = gpmlRotation * 180 / Math.PI;
            if (gpmlRotation !== 0) {
                dataElement.rotation = dataRotation;
            }
            /*
            // This conversion changes the rotation to reflect the angle between the green rotation
            // control dot in PathVisio-Java and the X-axis.
            // The units are radians, unlike the units for dataRotation.
            var angleToControlPoint = 2 * Math.PI - gpmlRotation;
            //*/
        },
        Shape: processShapeType,
        ShapeType: processShapeType,
        //Shape: this.ShapeType,
        Style: function (gpmlValue) {
            if (gpmlElementName === 'Group') {
                dataElement['gpml:Style'] = gpmlValue;
                dataElement.type = gpml_utilities_1.unionLSV(dataElement.type, 'Group' + gpmlValue);
            }
            else {
                throw new Error('Did not expect Style attribute on ' + gpmlElementName);
            }
        },
        TextLabel: function (gpmlTextLabelValue) {
            if (gpmlTextLabelValue) {
                dataElement.displayName = he_1.decode(gpmlTextLabelValue);
            }
        },
        Type: function (gpmlValue) {
            var wpType;
            if (wpType) {
                wpType = gpmlValue;
            }
            else if (gpmlElementName === 'DataNode') {
                // NOTE: when the DataNode is set to have a Type of "Unknown" in PathVisio-Java,
                // it is serialized into GPML without a Type attribute.
                wpType = 'Unknown';
            }
            if (wpType) {
                dataElement.wpType = gpmlValue;
            }
        },
        Valign: function (gpmlValignValue) {
            dataElement.verticalAlign = tower_strcase_1.paramCase(gpmlValignValue);
        },
        Version: function (gpmlValue) {
            // This usually appears to be referring to the version from the DataSource,
            // not to the WikiPathways version.
            dataElement.dataSource += ', version: ' + gpmlValue;
        },
        Width: function (gpmlValue) {
            // NOTE: this will be corrected, if needed, when CenterY is evaluated
            dataElement.width = parseAsNonNaNNumber(gpmlValue) + dataBorderWidth;
            if (lineStyleIsDouble) {
                dataElement.width += dataBorderWidth;
            }
        },
        ZOrder: function (gpmlZOrderValue) {
            dataElement.zIndex = parseAsNonNaNNumber(gpmlZOrderValue);
        },
        // everything below in this object: helper values/functions
        gpmlColorToCssColor: function (gpmlColor) {
            var color;
            if (gpmlColor.toLowerCase() === 'transparent') {
                return 'transparent';
            }
            else {
                color = new RGBColor(gpmlColor);
                if (color.ok) {
                    return color.toHex();
                }
                else {
                    console.warn('Could not convert GPML Color value of "' + gpmlColor +
                        '" to a valid CSS color. Using "#c0c0c0" as a fallback.');
                    return '#c0c0c0';
                }
            }
        }
    };
    dataElement.type = dataElement.type || [];
    dataElement.type.push(gpmlElementName);
    dataElement = gpml_utilities_1.convertAttributesToJson(gpmlElement, dataElement, gpmlToDataConverter, ATTRIBUTE_DEPENDENCY_ORDER);
    data[gpmlElementName].push(dataElement.id);
    if (gpmlElement.name !== 'Pathway') {
        data.elementMap[dataElement.id] = dataElement;
    }
    else {
        data = dataElement;
    }
    return data;
}
exports.fromGPML = fromGPML;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoieG1sLWVsZW1lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMveG1sLWVsZW1lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGlDQUE0QztBQUM1Qyx5Q0FBMEQ7QUFDMUQsbURBQTZJO0FBQzdJLHlCQUEwQjtBQUMxQiwrQ0FBd0M7QUFDeEMsbUNBQXNDO0FBRXRDLG1DQUFnRTtBQUNoRSxxQ0FBa0U7QUFDbEUsaUNBQThEO0FBQzlELHlDQUFxRTtBQUNyRSxtREFBK0U7QUFDL0UsNkNBQTBFO0FBQzFFLGlDQUE4RDtBQUM5RCxpQ0FBOEQ7QUFDOUQsaUNBQThEO0FBRTlELElBQU0sZ0JBQWdCLEdBQUc7SUFDeEIsTUFBTSxFQUFFLHNCQUFtQjtJQUMzQixPQUFPLEVBQUUsdUJBQW9CO0lBQzdCLEtBQUssRUFBRSxxQkFBa0I7SUFDekIsUUFBUSxFQUFFLHlCQUFxQjtJQUMvQixhQUFhLEVBQUUsOEJBQTBCO0lBQ3pDLFdBQVcsRUFBRSwyQkFBd0I7SUFDckMsS0FBSyxFQUFFLHFCQUFrQjtJQUN6QixLQUFLLEVBQUUscUJBQWtCO0lBQ3pCLEtBQUssRUFBRSxxQkFBa0I7Q0FDekIsQ0FBQztBQUVGLDZCQUE2QixDQUFrQjtJQUM5QyxJQUFNLE1BQU0sR0FBRyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUM7SUFDekIsRUFBRSxDQUFDLENBQUMsY0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUNuQixNQUFNLElBQUksS0FBSyxDQUFDLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxDQUFDLENBQUMsR0FBRyxxQkFBcUIsQ0FBQyxDQUFDO0lBQ3ZFLENBQUM7SUFDRCxNQUFNLENBQUMsTUFBTSxDQUFDO0FBQ2YsQ0FBQztBQUVELElBQU0sUUFBUSxHQUFHO0lBQ2hCLFVBQVUsRUFBRTtRQUNYLFNBQVMsRUFBRTtZQUNWLElBQUksRUFBRSxXQUFXO1lBQ2pCLEtBQUssRUFBRSxRQUFRO1NBQ2Y7S0FDRDtDQUNELENBQUM7QUFFRix1QkFBOEIsV0FBVztJQUN4QyxJQUFNLGVBQWUsR0FBRyxXQUFXLENBQUMsSUFBSSxDQUFDO0lBQ3pDLEVBQUUsQ0FBQyxDQUFDLGdCQUFnQixDQUFDLGNBQWMsQ0FBQyxlQUFlLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDdEQsTUFBTSxDQUFDLGdCQUFnQixDQUFDLGVBQWUsQ0FBQyxDQUFDLFdBQVcsRUFBRSxRQUFRLENBQUMsQ0FBQztJQUNqRSxDQUFDO0lBQUMsSUFBSSxDQUFDLENBQUM7UUFDUCxNQUFNLENBQUMsOEJBQWlCLENBQUMsV0FBVyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBQ2pELENBQUM7QUFDRixDQUFDO0FBUEQsc0NBT0M7QUFBQSxDQUFDO0FBRUYsa0JBQXlCLElBQVUsRUFBRSxXQUErQixFQUFFLGdCQUE2QjtJQUNsRyxJQUFNLFdBQVcsR0FBRyxhQUFhLENBQUMsZ0JBQWdCLENBQUMsQ0FBQztJQUNwRCxJQUFNLGVBQWUsR0FBRyxXQUFXLENBQUMsZUFBZSxHQUFHLFdBQVcsQ0FBQyxJQUFJLENBQUM7SUFFdkUsK0NBQStDO0lBQy9DLDRDQUE0QztJQUM1QyxJQUFJLGFBQWEsR0FBRyxFQUFFLENBQUM7SUFDdkIsSUFBSSxpQkFBMEIsQ0FBQztJQUMvQixJQUFJLGVBQXVCLENBQUM7SUFDNUIsSUFBSSxZQUFvQixDQUFDO0lBRXpCLElBQU0sMEJBQTBCLEdBQXlCO1FBQ3hELFNBQVM7UUFDVCxTQUFTO1FBQ1QsVUFBVTtRQUNWLFVBQVU7UUFDVixNQUFNO1FBQ04sV0FBVztRQUNYLE1BQU07UUFDTixtQkFBbUI7UUFDbkIsVUFBVTtRQUNWLFdBQVc7UUFDWCxPQUFPO1FBQ1AsV0FBVztRQUNYLFdBQVc7UUFDWCxXQUFXO1FBQ1gsT0FBTztRQUNQLGVBQWU7UUFDZixPQUFPO1FBQ1AsUUFBUTtRQUNSLE1BQU07UUFDTixNQUFNO1FBQ04sU0FBUztRQUNULFNBQVM7UUFDVCxlQUFlO1FBQ2YsT0FBTztRQUNQLFVBQVU7UUFDVixVQUFVO1FBQ1YsSUFBSTtRQUNKLGFBQWE7UUFDYixTQUFTO0tBQ1QsQ0FBQztJQUVGLGlEQUFpRDtJQUNqRCwwQkFBMEIsU0FBUztRQUNsQyxhQUFhLEdBQUcsV0FBVyxDQUFDLE1BQU0sR0FBRyxTQUFTLENBQUM7SUFDaEQsQ0FBQztJQUVELElBQU0sdUJBQXVCLEdBQUc7UUFDL0IsTUFBTSxFQUFFLFFBQVE7UUFDaEIsSUFBSSxFQUFFLE9BQU87UUFDYixLQUFLLEVBQUUsS0FBSztLQUNaLENBQUM7SUFFRixJQUFJLG1CQUFtQixHQUFHO1FBQ3pCLEtBQUssRUFBRSxVQUFTLGNBQWM7WUFDN0IsV0FBVyxDQUFDLFNBQVMsR0FBRyx1QkFBdUIsQ0FBQyxjQUFjLENBQUMsQ0FBQztRQUNqRSxDQUFDO1FBQ0QsU0FBUyxFQUFFLFVBQVMsU0FBUztZQUM1Qix1RkFBdUY7WUFDdkYsNkVBQTZFO1lBQzdFLDJEQUEyRDtZQUMzRCxTQUFTLENBQUMsT0FBTyxDQUFDLFVBQVMsZ0JBQWdCO2dCQUMxQyxXQUFXLEdBQUcsb0JBQWlCLENBQUMsV0FBVyxFQUFFLFdBQVcsRUFBRSxnQkFBZ0IsQ0FBQyxDQUFBO1lBQzVFLENBQUMsQ0FBQyxDQUFDO1FBQ0osQ0FBQztRQUNELE1BQU0sRUFBRSxVQUFTLFNBQVM7WUFDekIsRUFBRSxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQztnQkFDZixXQUFXLENBQUMsTUFBTSxHQUFHLFdBQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQztZQUN4QyxDQUFDO1FBQ0YsQ0FBQztRQUNELFNBQVMsRUFBRSxVQUFTLFNBQW1CO1lBQ3RDLHlEQUF5RDtZQUN6RCwyREFBMkQ7WUFDM0QsRUFBRSxDQUFDLENBQUMsQ0FBQyxnQkFBTyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQztnQkFDekIsV0FBVyxDQUFDLFFBQVEsR0FBRyxTQUFTLENBQUMsR0FBRyxDQUFDLDBDQUF5QixDQUFDLENBQUM7WUFDakUsQ0FBQztRQUNGLENBQUM7UUFDRCxXQUFXLEVBQUUsVUFBUyxTQUFTO1lBQzlCLFdBQVcsQ0FBQyxNQUFNLEdBQUcsbUJBQW1CLENBQUMsU0FBUyxDQUFDLENBQUM7UUFDckQsQ0FBQztRQUNELFVBQVUsRUFBRSxVQUFTLFNBQVM7WUFDN0IsV0FBVyxDQUFDLEtBQUssR0FBRyxtQkFBbUIsQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUNwRCxDQUFDO1FBQ0QsT0FBTyxFQUFFLFVBQVMsU0FBUztZQUMxQixXQUFXLENBQUMsQ0FBQyxHQUFHLG1CQUFtQixDQUFDLFNBQVMsQ0FBQyxHQUFHLFdBQVcsQ0FBQyxLQUFLLEdBQUcsQ0FBQyxDQUFDO1FBQ3hFLENBQUM7UUFDRCxPQUFPLEVBQUUsVUFBUyxTQUFTO1lBQzFCLFdBQVcsQ0FBQyxDQUFDLEdBQUcsbUJBQW1CLENBQUMsU0FBUyxDQUFDLEdBQUcsV0FBVyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7WUFFeEUsSUFBSSxzQkFBc0IsR0FBRyxFQUFFLENBQUM7WUFFaEMseUNBQXlDO1lBQ3pDLEVBQUU7WUFDRiwrREFBK0Q7WUFDL0QsNkRBQTZEO1lBQzdELDREQUE0RDtZQUM1RCw4Q0FBOEM7WUFFOUMsSUFBSSxZQUFZLENBQUM7WUFDakIsSUFBSSxZQUFZLENBQUM7WUFDakIsSUFBSSxNQUFNLENBQUM7WUFDWCxJQUFJLE1BQU0sQ0FBQztZQUVYLEVBQUUsQ0FBQyxDQUFDLGFBQWEsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDO2dCQUNsQyxpRkFBaUY7Z0JBQ2pGLHdFQUF3RTtnQkFDeEUsZ0ZBQWdGO2dCQUNoRiwrQkFBK0I7Z0JBQy9CLE1BQU0sR0FBRyxDQUFDLENBQUMsV0FBVyxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUMsR0FBRyxJQUFJLENBQUMsR0FBRyxXQUFXLENBQUMsS0FBSyxDQUFDO2dCQUNqRSxNQUFNLEdBQUcsQ0FBQyxDQUFDLFdBQVcsQ0FBQyxNQUFNLEdBQUcsSUFBSSxDQUFDLEdBQUcsSUFBSSxDQUFDLEdBQUcsV0FBVyxDQUFDLE1BQU0sQ0FBQztnQkFDbkUsWUFBWSxHQUFHLElBQUksR0FBRyxXQUFXLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQztnQkFDL0MsWUFBWSxHQUFHLENBQUMsQ0FBQztnQkFFakIsRUFBRSxDQUFDLENBQUMsT0FBTyxZQUFZLEtBQUssUUFBUSxJQUFJLFlBQVksS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUM1RCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7d0JBQzNCLEdBQUcsRUFBRSxRQUFRO3dCQUNiLEtBQUssRUFBRSxZQUFZO3FCQUNuQixDQUFDLENBQUM7Z0JBQ0osQ0FBQztnQkFFRCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7b0JBQzNCLEdBQUcsRUFBRSxXQUFXO29CQUNoQixLQUFLLEVBQUUsQ0FBQyxZQUFZLEVBQUUsWUFBWSxDQUFDO2lCQUNuQyxDQUFDLENBQUM7Z0JBRUgsRUFBRSxDQUFDLENBQUMsT0FBTyxZQUFZLEtBQUssUUFBUSxJQUFJLFlBQVksS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUM1RCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7d0JBQzNCLEdBQUcsRUFBRSxRQUFRO3dCQUNiLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsWUFBWTtxQkFDMUIsQ0FBQyxDQUFDO2dCQUNKLENBQUM7Z0JBRUQsc0JBQXNCLENBQUMsSUFBSSxDQUFDO29CQUMzQixHQUFHLEVBQUUsT0FBTztvQkFDWixLQUFLLEVBQUUsQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDO2lCQUN2QixDQUFDLENBQUM7WUFFSixDQUFDO1lBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLGFBQWEsS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDO2dCQUN4QyxNQUFNLEdBQUcsQ0FBQyxDQUFDO2dCQUNYLE1BQU0sR0FBRyxJQUFJLENBQUM7Z0JBQ2Qsc0JBQXNCLENBQUMsSUFBSSxDQUFDO29CQUMzQixHQUFHLEVBQUUsT0FBTztvQkFDWixLQUFLLEVBQUUsQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDO2lCQUN2QixDQUFDLENBQUM7WUFDSixDQUFDO1lBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLGFBQWEsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDO2dCQUN6QyxNQUFNLEdBQUcsSUFBSSxDQUFDO2dCQUNkLE1BQU0sR0FBRyxJQUFJLENBQUM7Z0JBQ2QsWUFBWSxHQUFHLEtBQUssR0FBRyxXQUFXLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQztnQkFDaEQsWUFBWSxHQUFHLENBQUMsQ0FBQztnQkFFakIsRUFBRSxDQUFDLENBQUMsT0FBTyxZQUFZLEtBQUssUUFBUSxJQUFJLFlBQVksS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUM1RCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7d0JBQzNCLEdBQUcsRUFBRSxRQUFRO3dCQUNiLEtBQUssRUFBRSxZQUFZO3FCQUNuQixDQUFDLENBQUM7Z0JBQ0osQ0FBQztnQkFFRCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7b0JBQzNCLEdBQUcsRUFBRSxXQUFXO29CQUNoQixLQUFLLEVBQUUsQ0FBQyxZQUFZLEVBQUUsWUFBWSxDQUFDO2lCQUNuQyxDQUFDLENBQUM7Z0JBRUgsRUFBRSxDQUFDLENBQUMsT0FBTyxZQUFZLEtBQUssUUFBUSxJQUFJLFlBQVksS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUM1RCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7d0JBQzNCLEdBQUcsRUFBRSxRQUFRO3dCQUNiLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsWUFBWTtxQkFDMUIsQ0FBQyxDQUFDO2dCQUNKLENBQUM7Z0JBRUQsc0JBQXNCLENBQUMsSUFBSSxDQUFDO29CQUMzQixHQUFHLEVBQUUsT0FBTztvQkFDWixLQUFLLEVBQUUsQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDO2lCQUN2QixDQUFDLENBQUM7WUFDSixDQUFDO1lBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLGFBQWEsS0FBSyxLQUFLLENBQUMsQ0FBQyxDQUFDO2dCQUNwQyxNQUFNLEdBQUcsQ0FBQyxDQUFDO2dCQUNYLE1BQU0sR0FBRyxHQUFHLENBQUM7Z0JBQ2IsWUFBWSxHQUFHLENBQUMsQ0FBQztnQkFDakIsWUFBWSxHQUFHLFdBQVcsQ0FBQyxNQUFNLEdBQUcsTUFBTSxHQUFHLENBQUMsQ0FBQztnQkFFL0MsRUFBRSxDQUFDLENBQUMsT0FBTyxZQUFZLEtBQUssUUFBUSxJQUFJLFlBQVksS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUM1RCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7d0JBQzNCLEdBQUcsRUFBRSxRQUFRO3dCQUNiLEtBQUssRUFBRSxZQUFZO3FCQUNuQixDQUFDLENBQUM7Z0JBQ0osQ0FBQztnQkFFRCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7b0JBQzNCLEdBQUcsRUFBRSxXQUFXO29CQUNoQixLQUFLLEVBQUUsQ0FBQyxZQUFZLEVBQUUsWUFBWSxDQUFDO2lCQUNuQyxDQUFDLENBQUM7Z0JBRUgsRUFBRSxDQUFDLENBQUMsT0FBTyxZQUFZLEtBQUssUUFBUSxJQUFJLFlBQVksS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO29CQUM1RCxzQkFBc0IsQ0FBQyxJQUFJLENBQUM7d0JBQzNCLEdBQUcsRUFBRSxRQUFRO3dCQUNiLEtBQUssRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsWUFBWTtxQkFDMUIsQ0FBQyxDQUFDO2dCQUNKLENBQUM7Z0JBRUQsc0JBQXNCLENBQUMsSUFBSSxDQUFDO29CQUMzQixHQUFHLEVBQUUsT0FBTztvQkFDWixLQUFLLEVBQUUsQ0FBQyxNQUFNLEVBQUUsTUFBTSxDQUFDO2lCQUN2QixDQUFDLENBQUM7WUFDSixDQUFDO1lBQ0Q7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O2dCQWdDSTtZQUVKLFdBQVcsR0FBRywwQkFBUyxDQUFDO2dCQUN2QixPQUFPLEVBQUUsV0FBVztnQkFDcEIsc0JBQXNCLEVBQUUsc0JBQXNCO2FBQzlDLENBQUMsQ0FBQztRQUNKLENBQUM7UUFDRCxLQUFLLEVBQUUsVUFBUyxjQUFjO1lBQzdCLElBQU0sUUFBUSxHQUFHLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxjQUFjLENBQUMsQ0FBQztZQUMxRCxXQUFXLENBQUMsS0FBSyxHQUFHLFFBQVEsQ0FBQztRQUM5QixDQUFDO1FBQ0QsT0FBTyxFQUFFLFVBQVMsU0FBbUI7WUFDcEMsdURBQXVEO1lBQ3ZELCtEQUErRDtZQUMvRCxFQUFFLENBQUMsQ0FBQyxDQUFDLGdCQUFPLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDO2dCQUN6QixXQUFXLENBQUMsT0FBTyxHQUFHLFNBQVMsQ0FBQyxHQUFHLENBQUMsVUFBQyxDQUFDLElBQUssT0FBQSxXQUFNLENBQUMsQ0FBQyxDQUFDLEVBQVQsQ0FBUyxDQUFDLENBQUM7WUFDdkQsQ0FBQztRQUNGLENBQUM7UUFDRCxhQUFhLEVBQUUsVUFBUyxzQkFBc0I7WUFDN0MsSUFBTSxpQkFBaUIsR0FBRyxzQkFBc0IsQ0FBQztZQUNqRCxXQUFXLENBQUMsTUFBTSxHQUFHLGlCQUFpQixHQUFHLE1BQU0sQ0FBQztRQUNqRCxDQUFDO1FBQ0QsUUFBUSxFQUFFLFVBQVMsU0FBUztZQUMzQixFQUFFLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDO2dCQUNmLFdBQVcsQ0FBQyxNQUFNLEdBQUcsU0FBUyxDQUFDLElBQUksRUFBRSxDQUFDO1lBQ3ZDLENBQUM7UUFDRixDQUFDO1FBQ0QsYUFBYSxFQUFFLFVBQVMsU0FBUztZQUNoQyxFQUFFLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDO2dCQUNmLFdBQVcsQ0FBQyxVQUFVLEdBQUcsV0FBTSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1lBQzVDLENBQUM7UUFDRixDQUFDO1FBQ0QsS0FBSyxFQUFFLFVBQVMsU0FBUztZQUN4QixFQUFFLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDO2dCQUNmLFdBQVcsQ0FBQyxLQUFLLEdBQUcsV0FBTSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1lBQ3ZDLENBQUM7UUFDRixDQUFDO1FBQ0QsU0FBUyxFQUFFLFVBQVMsa0JBQWtCO1lBQ3JDLElBQU0sUUFBUSxHQUFHLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDO1lBQzlELEVBQUUsQ0FBQyxDQUFDLGFBQWEsQ0FBQyxXQUFXLEVBQUUsS0FBSyxNQUFNLENBQUMsQ0FBQyxDQUFDO2dCQUM1QyxXQUFXLENBQUMsZUFBZSxHQUFHLFFBQVEsQ0FBQztZQUN4QyxDQUFDO1lBQUMsSUFBSSxDQUFDLENBQUM7Z0JBQ1AsV0FBVyxDQUFDLGVBQWUsR0FBRyxhQUFhLENBQUM7WUFDN0MsQ0FBQztRQUNGLENBQUM7UUFDRCxXQUFXLEVBQUUsVUFBUyxvQkFBb0I7WUFDekMsSUFBTSxjQUFjLEdBQUcsbUJBQW1CLENBQUMsb0JBQW9CLENBQUMsQ0FBQztZQUNqRSxXQUFXLENBQUMsV0FBVyxHQUFHLGNBQWMsQ0FBQztRQUMxQyxDQUFDO1FBQ0QsUUFBUSxFQUFFLFVBQVMsaUJBQWlCO1lBQ25DLFdBQVcsQ0FBQyxVQUFVLEdBQUcsaUJBQWlCLENBQUM7UUFDNUMsQ0FBQztRQUNELFFBQVEsRUFBRSxVQUFTLGlCQUFpQjtZQUNuQyxXQUFXLENBQUMsUUFBUSxHQUFHLG1CQUFtQixDQUFDLGlCQUFpQixDQUFDLENBQUM7UUFDL0QsQ0FBQztRQUNELFNBQVMsRUFBRSxVQUFTLGtCQUFrQjtZQUNyQyxJQUFNLFlBQVksR0FBRyxrQkFBa0IsQ0FBQyxXQUFXLEVBQUUsQ0FBQztZQUN0RCxXQUFXLENBQUMsU0FBUyxHQUFHLFlBQVksQ0FBQztRQUN0QyxDQUFDO1FBQ0QsVUFBVSxFQUFFLFVBQVMsbUJBQW1CO1lBQ3ZDLElBQU0sYUFBYSxHQUFHLG1CQUFtQixDQUFDLFdBQVcsRUFBRSxDQUFDO1lBQ3hELFdBQVcsQ0FBQyxVQUFVLEdBQUcsYUFBYSxDQUFDO1FBQ3hDLENBQUM7UUFDRCxPQUFPLEVBQUUsVUFBUyxTQUFTO1lBQzFCLFdBQVcsQ0FBQyxFQUFFLEdBQUcsU0FBUyxDQUFDO1FBQzVCLENBQUM7UUFDRCxRQUFRLEVBQUUsVUFBUyxTQUFTO1lBQzNCLFdBQVcsQ0FBQyxZQUFZLEdBQUcsU0FBUyxDQUFDO1FBQ3RDLENBQUM7UUFDRCxPQUFPLEVBQUUsVUFBUyxTQUFpQjtZQUNsQyxJQUFJLENBQUMsZ0JBQWdCLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxHQUFHLFNBQVMsQ0FBQztRQUNuRCxDQUFDO1FBQ0QsUUFBUSxFQUFFLFVBQVMsU0FBUztZQUMzQixJQUFJLGFBQWEsR0FBRyxJQUFJLENBQUMscUJBQXFCLENBQUMsU0FBUyxDQUFDLEdBQUcsSUFBSSxDQUFDLHFCQUFxQixDQUFDLFNBQVMsQ0FBQyxJQUFJLEVBQUUsQ0FBQztZQUN4RyxhQUFhLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUNwQyxDQUFDO1FBQ0QsTUFBTSxFQUFFLFVBQVMsU0FBUztZQUN6QixxRUFBcUU7WUFDckUsV0FBVyxDQUFDLE1BQU0sR0FBRyxtQkFBbUIsQ0FBQyxTQUFTLENBQUMsR0FBRyxlQUFlLENBQUM7WUFDdEUsRUFBRSxDQUFDLENBQUMsaUJBQWlCLENBQUMsQ0FBQyxDQUFDO2dCQUN2QixXQUFXLENBQUMsTUFBTSxJQUFJLGVBQWUsQ0FBQztZQUN2QyxDQUFDO1FBQ0YsQ0FBQztRQUNELElBQUksRUFBRSxVQUFTLGFBQWE7WUFDM0IsRUFBRSxDQUFDLENBQUMsYUFBYSxDQUFDLENBQUMsQ0FBQztnQkFDbkIsV0FBVyxDQUFDLElBQUksR0FBRyxTQUFTLENBQUMsV0FBTSxDQUFDLGFBQWEsQ0FBQyxDQUFDLENBQUM7WUFDckQsQ0FBQztRQUNGLENBQUM7UUFDRCxFQUFFLEVBQUUsVUFBUyxTQUFTO1lBQ3JCLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUM7Z0JBQ2YsV0FBVyxDQUFDLElBQUksR0FBRyxTQUFTLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDckMsQ0FBQztRQUNGLENBQUM7UUFDRCxlQUFlLEVBQUUsVUFBUyxTQUFTO1lBQ2xDLFdBQVcsQ0FBQyxZQUFZLEdBQUcsU0FBUyxDQUFDO1FBQ3RDLENBQUM7UUFDRCxPQUFPLEVBQUUsVUFBUyxTQUFTO1lBQzFCLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUM7Z0JBQ2YsV0FBVyxDQUFDLE9BQU8sR0FBRyxXQUFNLENBQUMsU0FBUyxDQUFDLENBQUM7WUFDekMsQ0FBQztRQUNGLENBQUM7UUFDRCxTQUFTLEVBQUUsVUFBUyxrQkFBa0I7WUFDckMsV0FBVyxDQUFDLFNBQVMsR0FBRyxrQkFBa0IsQ0FBQztZQUMzQyxJQUFJLG1CQUFtQixDQUFDO1lBQ3hCLDJEQUEyRDtZQUMzRCxFQUFFLENBQUMsQ0FBQyxrQkFBa0IsS0FBSyxRQUFRLENBQUMsQ0FBQyxDQUFDO2dCQUNyQyxtQkFBbUIsR0FBRyxLQUFLLENBQUM7Z0JBQzVCLFdBQVcsQ0FBQyxlQUFlLEdBQUcsbUJBQW1CLENBQUM7WUFDbkQsQ0FBQztZQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxrQkFBa0IsS0FBSyxRQUFRLENBQUMsQ0FBQyxDQUFDO2dCQUM1QyxpQkFBaUIsR0FBRyxJQUFJLENBQUM7WUFDMUIsQ0FBQztRQUNGLENBQUM7UUFDRCxhQUFhLEVBQUUsVUFBUyxzQkFBc0I7WUFDN0MsZUFBZSxHQUFHLG1CQUFtQixDQUFDLHNCQUFzQixDQUFDLENBQUM7WUFDOUQsMERBQTBEO1lBQzFELDhEQUE4RDtZQUM5RCxFQUFFO1lBQ0YsZ0VBQWdFO1lBQ2hFLGlFQUFpRTtZQUNqRSxzQ0FBc0M7WUFDdEMsRUFBRTtZQUNGLHVFQUF1RTtZQUN2RSxtRUFBbUU7WUFDbkUsRUFBRTtZQUNGLG9FQUFvRTtZQUNwRSx3QkFBd0I7WUFDeEIsdURBQXVEO1lBQ3ZELDREQUE0RDtZQUM1RCxFQUFFO1lBQ0YsOEVBQThFO1lBQzlFLGdGQUFnRjtZQUNoRixvRUFBb0U7WUFDcEUsRUFBRTtZQUNGLCtDQUErQztZQUMvQyxpREFBaUQ7WUFDakQsNEVBQTRFO1lBQzVFLG9CQUFvQjtZQUNwQixFQUFFO1lBQ0YsMEVBQTBFO1lBQzFFLCtFQUErRTtZQUMvRSwrRUFBK0U7WUFFL0UsV0FBVyxDQUFDLFdBQVcsR0FBRyxlQUFlLENBQUM7UUFDM0MsQ0FBQztRQUNELFVBQVUsRUFBRSxVQUFTLFNBQVM7WUFDN0IsRUFBRSxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQztnQkFDZixXQUFXLENBQUMsVUFBVSxHQUFHLFdBQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQztZQUM1QyxDQUFDO1FBQ0YsQ0FBQztRQUNELElBQUksRUFBRSxVQUFTLFNBQVM7WUFDdkIsRUFBRSxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQztnQkFDZixXQUFXLENBQUMsSUFBSSxHQUFHLFdBQU0sQ0FBQyxTQUFTLENBQUMsQ0FBQztnQkFDckMsSUFBTSxTQUFTLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDeEMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVM7b0JBQ2IsU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDO29CQUNyQixDQUFDLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUM7b0JBQ3ZCLFNBQVMsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUMsTUFBTSxLQUFLLENBQUM7b0JBQ2xDLENBQUMsQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQztvQkFDdkIsU0FBUyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztvQkFDM0MsV0FBVyxDQUFDLFlBQVksR0FBRyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUM7b0JBQ3hDLFdBQVcsQ0FBQyxXQUFXLEdBQUcsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsRUFBRSxDQUFDLENBQUM7Z0JBQ3pELENBQUM7Z0JBQUMsSUFBSSxDQUFDLENBQUM7b0JBQ1AsV0FBVyxDQUFDLFlBQVksR0FBRyxTQUFTLENBQUM7b0JBQ3JDLFdBQVcsQ0FBQyxXQUFXLEdBQUcsU0FBUyxDQUFDO2dCQUNyQyxDQUFDO1lBQ0YsQ0FBQztRQUNGLENBQUM7UUFDRCxRQUFRLEVBQUUsVUFBUyxTQUFTO1lBQzNCLFdBQVcsQ0FBQyxRQUFRLEdBQUcsU0FBUyxDQUFDO1FBQ2xDLENBQUM7UUFDRCxPQUFPLEVBQUUsVUFBUyxnQkFBZ0I7WUFDakMsV0FBVyxDQUFDLE9BQU8sR0FBRyxnQkFBZ0IsQ0FBQztRQUN4QyxDQUFDO1FBQ0QsS0FBSyxFQUFFLFVBQVMsU0FBUztZQUN4QiwwR0FBMEc7WUFDMUcsV0FBVyxDQUFDLFlBQVksQ0FBQyxHQUFHLFNBQVMsQ0FBQztRQUN2QyxDQUFDO1FBQ0QsUUFBUSxFQUFFLFVBQVMsaUJBQWlCO1lBQ25DLFdBQVcsQ0FBQyxpQkFBaUIsR0FBRztnQkFDL0IsUUFBUSxFQUFFLENBQUMsbUJBQW1CLENBQUMsaUJBQWlCLENBQUMsQ0FBQzthQUNsRCxDQUFDO1FBQ0gsQ0FBQztRQUNELElBQUksRUFBRSxVQUFTLFNBQVM7WUFDdkIsSUFBSSxpQkFBaUIsR0FBRyxXQUFXLENBQUMsaUJBQWlCLEdBQUcsV0FBVyxDQUFDLGlCQUFpQixJQUFJLEVBQXVCLENBQUM7WUFDakgsSUFBSSxRQUFRLEdBQUcsaUJBQWlCLENBQUMsUUFBUSxHQUFHLGlCQUFpQixDQUFDLFFBQVEsSUFBSSxFQUFFLENBQUM7WUFDN0UsSUFBTSxRQUFRLEdBQUcsbUJBQW1CLENBQUMsU0FBUyxDQUFDLENBQUM7WUFDaEQsUUFBUSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsUUFBUSxHQUFHLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUNsQyxDQUFDO1FBQ0QsSUFBSSxFQUFFLFVBQVMsU0FBUztZQUN2QixJQUFJLGlCQUFpQixHQUFHLFdBQVcsQ0FBQyxpQkFBaUIsR0FBRyxXQUFXLENBQUMsaUJBQWlCLElBQUksRUFBdUIsQ0FBQztZQUNqSCxJQUFJLFFBQVEsR0FBRyxpQkFBaUIsQ0FBQyxRQUFRLEdBQUcsaUJBQWlCLENBQUMsUUFBUSxJQUFJLEVBQUUsQ0FBQztZQUM3RSxJQUFNLFFBQVEsR0FBRyxtQkFBbUIsQ0FBQyxTQUFTLENBQUMsQ0FBQztZQUNoRCxRQUFRLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEdBQUcsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ2xDLENBQUM7UUFDRCxRQUFRLEVBQUUsVUFBUyxTQUFTO1lBQzNCLGtFQUFrRTtZQUNsRSwrQkFBK0I7WUFDL0IseUNBQXlDO1lBQ3pDLHNFQUFzRTtZQUN0RSx1REFBdUQ7WUFFdkQsWUFBWSxHQUFHLG1CQUFtQixDQUFDLFNBQVMsQ0FBQyxDQUFDO1lBRTlDLDJGQUEyRjtZQUMzRixtQ0FBbUM7WUFDbkMsSUFBTSxZQUFZLEdBQUcsWUFBWSxHQUFHLEdBQUcsR0FBRyxJQUFJLENBQUMsRUFBRSxDQUFDO1lBQ2xELEVBQUUsQ0FBQyxDQUFDLFlBQVksS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO2dCQUN4QixXQUFXLENBQUMsUUFBUSxHQUFHLFlBQVksQ0FBQztZQUNyQyxDQUFDO1lBRUQ7Ozs7O2dCQUtJO1FBQ0wsQ0FBQztRQUNELEtBQUssRUFBRSxnQkFBZ0I7UUFDdkIsU0FBUyxFQUFFLGdCQUFnQjtRQUMzQix3QkFBd0I7UUFDeEIsS0FBSyxFQUFFLFVBQVMsU0FBUztZQUN4QixFQUFFLENBQUMsQ0FBQyxlQUFlLEtBQUssT0FBTyxDQUFDLENBQUMsQ0FBQztnQkFDakMsV0FBVyxDQUFDLFlBQVksQ0FBQyxHQUFHLFNBQVMsQ0FBQztnQkFDdEMsV0FBVyxDQUFDLElBQUksR0FBRyx5QkFBUSxDQUFDLFdBQVcsQ0FBQyxJQUFJLEVBQUUsT0FBTyxHQUFHLFNBQVMsQ0FBYSxDQUFDO1lBQ2hGLENBQUM7WUFBQyxJQUFJLENBQUMsQ0FBQztnQkFDUCxNQUFNLElBQUksS0FBSyxDQUFDLG9DQUFvQyxHQUFHLGVBQWUsQ0FBQyxDQUFDO1lBQ3pFLENBQUM7UUFDRixDQUFDO1FBQ0QsU0FBUyxFQUFFLFVBQVMsa0JBQWtCO1lBQ3JDLEVBQUUsQ0FBQyxDQUFDLGtCQUFrQixDQUFDLENBQUMsQ0FBQztnQkFDeEIsV0FBVyxDQUFDLFdBQVcsR0FBRyxXQUFNLENBQUMsa0JBQWtCLENBQUMsQ0FBQztZQUN0RCxDQUFDO1FBQ0YsQ0FBQztRQUNELElBQUksRUFBRSxVQUFTLFNBQVM7WUFDdkIsSUFBSSxNQUFNLENBQUM7WUFDWCxFQUFFLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO2dCQUNaLE1BQU0sR0FBRyxTQUFTLENBQUM7WUFDcEIsQ0FBQztZQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxlQUFlLEtBQUssVUFBVSxDQUFDLENBQUMsQ0FBQztnQkFDM0MsZ0ZBQWdGO2dCQUNoRix1REFBdUQ7Z0JBQ3ZELE1BQU0sR0FBRyxTQUFTLENBQUM7WUFDcEIsQ0FBQztZQUNELEVBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUM7Z0JBQ1osV0FBVyxDQUFDLE1BQU0sR0FBRyxTQUFTLENBQUM7WUFDaEMsQ0FBQztRQUNGLENBQUM7UUFDRCxNQUFNLEVBQUUsVUFBUyxlQUFlO1lBQy9CLFdBQVcsQ0FBQyxhQUFhLEdBQUcseUJBQVMsQ0FBQyxlQUFlLENBQUMsQ0FBQztRQUN4RCxDQUFDO1FBQ0QsT0FBTyxFQUFFLFVBQVMsU0FBUztZQUMxQiwyRUFBMkU7WUFDM0UsbUNBQW1DO1lBQ25DLFdBQVcsQ0FBQyxVQUFVLElBQUksYUFBYSxHQUFHLFNBQVMsQ0FBQztRQUNyRCxDQUFDO1FBQ0QsS0FBSyxFQUFFLFVBQVMsU0FBUztZQUN4QixxRUFBcUU7WUFDckUsV0FBVyxDQUFDLEtBQUssR0FBRyxtQkFBbUIsQ0FBQyxTQUFTLENBQUMsR0FBRyxlQUFlLENBQUM7WUFDckUsRUFBRSxDQUFDLENBQUMsaUJBQWlCLENBQUMsQ0FBQyxDQUFDO2dCQUN2QixXQUFXLENBQUMsS0FBSyxJQUFJLGVBQWUsQ0FBQztZQUN0QyxDQUFDO1FBQ0YsQ0FBQztRQUNELE1BQU0sRUFBRSxVQUFTLGVBQWU7WUFDL0IsV0FBVyxDQUFDLE1BQU0sR0FBRyxtQkFBbUIsQ0FBQyxlQUFlLENBQUMsQ0FBQztRQUMzRCxDQUFDO1FBQ0QsMkRBQTJEO1FBQzNELG1CQUFtQixFQUFFLFVBQVMsU0FBUztZQUN0QyxJQUFJLEtBQUssQ0FBQztZQUNWLEVBQUUsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxXQUFXLEVBQUUsS0FBSyxhQUFhLENBQUMsQ0FBQyxDQUFDO2dCQUMvQyxNQUFNLENBQUMsYUFBYSxDQUFDO1lBQ3RCLENBQUM7WUFBQyxJQUFJLENBQUMsQ0FBQztnQkFDUCxLQUFLLEdBQUcsSUFBSSxRQUFRLENBQUMsU0FBUyxDQUFDLENBQUM7Z0JBQ2hDLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO29CQUNkLE1BQU0sQ0FBQyxLQUFLLENBQUMsS0FBSyxFQUFFLENBQUM7Z0JBQ3RCLENBQUM7Z0JBQUMsSUFBSSxDQUFDLENBQUM7b0JBQ1AsT0FBTyxDQUFDLElBQUksQ0FBQyx5Q0FBeUMsR0FBRyxTQUFTO3dCQUMzRCx3REFBd0QsQ0FBQyxDQUFDO29CQUNqRSxNQUFNLENBQUMsU0FBUyxDQUFDO2dCQUNsQixDQUFDO1lBQ0YsQ0FBQztRQUNGLENBQUM7S0FDRCxDQUFDO0lBRUYsV0FBVyxDQUFDLElBQUksR0FBRyxXQUFXLENBQUMsSUFBSSxJQUFJLEVBQUUsQ0FBQztJQUMxQyxXQUFXLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlLENBQUMsQ0FBQztJQUV2QyxXQUFXLEdBQUcsd0NBQXVCLENBQ25DLFdBQVcsRUFDWCxXQUFXLEVBQ1gsbUJBQW1CLEVBQ25CLDBCQUEwQixDQUMzQixDQUFDO0lBRUYsSUFBSSxDQUFDLGVBQWUsQ0FBQyxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLENBQUM7SUFFM0MsRUFBRSxDQUFDLENBQUMsV0FBVyxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDO1FBQ3BDLElBQUksQ0FBQyxVQUFVLENBQUMsV0FBVyxDQUFDLEVBQUUsQ0FBQyxHQUFHLFdBQVcsQ0FBQztJQUMvQyxDQUFDO0lBQUMsSUFBSSxDQUFDLENBQUM7UUFDUCxJQUFJLEdBQUcsV0FBVyxDQUFDO0lBQ3BCLENBQUM7SUFFRCxNQUFNLENBQUMsSUFBSSxDQUFDO0FBQ2IsQ0FBQztBQXpoQkQsNEJBeWhCQztBQUFBLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/xml-element.js
// module id = 714
// module chunks = 0